// extracted by mini-css-extract-plugin
module.exports = {"agreement":"TermsAndConditions_agreement__3sJ9l","text_container":"TermsAndConditions_text_container__2LZd_","text":"TermsAndConditions_text__1RfOr"};